import axios from 'axios';

export const LIST_DATA_UPDATE_INFO = '[CTM DATA] LIST DATA UPDATE INFO';

export const dataUpdateInfo = (tdValue) => async dispatch => {
    let current_user = JSON.parse(localStorage.getItem('current_user'));
    let token = current_user['authToken'];

    const request = axios.get(process.env.REACT_APP_SERVER + '/api/ctm/data-update-info', {
        headers: { Authorization: `Token ${token}` }
    });

    return request.then(response => {
        if (response.data.data) {
        return dispatch({
            type: LIST_DATA_UPDATE_INFO,
            data: response.data.data,
        });
        } else {
        //reject(response.data.error);
        }
    });
};